(function () {
    const accordions = document.querySelectorAll('[data-faq-accordion]');
    if (!accordions.length) return;

    accordions.forEach((accordion) => {
        const isSingle = accordion.getAttribute('data-faq-accordion-single') === 'true';

        accordion.addEventListener(
            'click',
            (event) => {
                const toggle = event.target.closest('[data-faq-toggle]');
                if (!toggle || !accordion.contains(toggle)) return;

                const item = toggle.closest('[data-faq-item]');
                if (!item) return;

                const isOpen = item.classList.contains('is-open');

                if (isSingle) {
                    const openItems = accordion.querySelectorAll('[data-faq-item].is-open');
                    openItems.forEach((openItem) => {
                        if (openItem === item) return;
                        openItem.classList.remove('is-open');
                        const openToggle = openItem.querySelector('[data-faq-toggle]');
                        if (openToggle) {
                            openToggle.setAttribute('aria-expanded', 'false');
                        }
                    });
                }

                item.classList.toggle('is-open', !isOpen);
                toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
            },
            { passive: true }
        );
    });
})();
